import React, { useCallback } from 'react';
import NonVirtualisedList from 'qs-components/Common/NonVirtualisedList';
import TagRow from './TagRow';
import { ReactComponent as TimesIcon } from 'qs-assets/Media/multiply.svg';
import './styles.scss';
import { getI18N } from 'qs-services/i18N';

export default ({ sortedTags, onClosePopover, onToggleTag, currentSelectedTags }) => {
  const { t } = getI18N();

  const renderItem = useCallback(
    ({ item: tag }) => {
      return (
        <TagRow
          tag={tag}
          onToggleTag={onToggleTag}
          isSelected={currentSelectedTags.has(tag.title)}
        />
      );
    },
    [onToggleTag, currentSelectedTags]
  );

  return (
    <div className="catalogueTagsPopoverContainer">
      <div className="catalogueTagsPopover">
        <NonVirtualisedList
          horizontal={false}
          data={sortedTags}
          renderItem={renderItem}
          keyExtractor={item => item.title}
          contentContainerClassName="popoverTagsList"
          ItemSeparatorComponent={() => <div className="popoverTagSeparator" />}
          ListHeaderComponent={() => (
            <div className="popoverTagHeader">
              <div className="popoverTagHeaderLeft">
                <div className="popoverTagHeaderTitle">{t('product_sub_categories')}</div>
                <div className="popoverTagHeaderSubtitle">
                  {t('tap_on_a_sub_category_to_filter')}
                </div>
              </div>

              <div className="popoverTagHeaderRight">
                <button className="closeButton" onClick={onClosePopover}>
                  <TimesIcon fill="#737F8E" className="closeButtonIcon" />
                </button>
              </div>
            </div>
          )}
          ListFooterComponent={() => <div className="popoverTagSeparator" />}
        />
      </div>
    </div>
  );
};
